export const formatToKey = (string) => {
    let formattedText = string
        .trim()
        .toLowerCase()
        .replace(/[^\p{L}0-9]+/gu, '-')
        .replace(/-+$/, '');
    return formattedText;
};
